import React, { useEffect, useState } from "react";
import {
  Headphones,
  User,
  Heart,
  ShoppingCart,
  Search,
  LogIn, Menu,
  Home,
  LogOut,
  Phone,
  Pocket
} from "react-feather";
import { Link } from "react-router-dom";
import logo from "../component/img/logoa.jpeg";
import { baseurl } from "../Baseurl";
import axios from "axios"; 
import SearchCompo from "./SearchCompo";
import DollarInr from "./DollarInr";

import { useCart } from "../context/CartContext";
import UserNotification from "./UserNotification";

function VisitorNavbar() {
  const [categories, setCategories] = useState([]);
  const cust_id = localStorage.getItem("cust_id");
  const { cartCount } = useCart();
  const cust_name = localStorage.getItem("cust_name"); 

  // Fetch categories from API
  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const response = await axios.get(`${baseurl}getCategory`);
        setCategories(response.data);
      } catch (error) {
        console.error("Error fetching categories:", error);
      }
    };
    fetchCategories();
  }, []);

  return (
    <header>
      {/* Custom CSS for Offcanvas */}
      <style>{`
        .offcanvas {
          background-color: #ffffff;
          border-right: 3px solid #ffc107; /* Warning yellow accent */
        }
        .offcanvas-header {
          background: #0a2264; /* Dark theme to match navbar */
          color: white;
          padding: 1.5rem 1rem;
        }
        .offcanvas-header .btn-close {
          filter: invert(1) grayscale(100%) brightness(200%); /* Make close button white */
        }
        .offcanvas-body {
          padding: 0;
        }
        .mblink {
          padding: 15px 20px !important;
          border-bottom: 1px solid #f0f0f0;
          font-weight: 500;
          color: #333 !important;
          display: flex;
          align-items: center;
          transition: all 0.3s ease;
        }
        .mblink:hover {
          background-color: #fff9e6;
          color: #ffc107 !important;
          padding-left: 25px !important;
        }
        .mblink svg {
          margin-right: 12px;
          color: #666;
        }
        .mblink:hover svg {
          color: #ffc107;
        }
        .logo2 {
          max-height: 50px;
          border-radius: 4px;
        }
        .offcanvas-footer-text {
          position: absolute;
          bottom: 20px;
          width: 100%;
          text-align: center;
          font-size: 12px;
          color: #aaa;
        }


        .modal-backdrop{
        z-index: 1040 !important;
        }



      `}</style>

      <div className="topbar text-white py-2 hide-on-mobile">
        <div className="container-fluid d-flex justify-content-between align-items-center">
          <span></span>
          <div className="d-flex">
            <Link to="/seller/login" target="_blank" className="text-white mx-2">
              &nbsp;Seller Login
            </Link>
            <span>|</span>
            <Link to="/seller/register" className="text-white mx-2">
              &nbsp;Sell On TSI
            </Link>
            <DollarInr />
          </div>
        </div>
      </div>

      <nav className="navbar navbar-expand-lg navbar-light py-1">
        <div className="container">
          <Link className="navbar-brand p-0 text-center" to="/">
            <img src={logo} alt="Toolband" className="brand-logo logo1" />
            <br />
            <span className="text-white">
              <strong>
                Tech <span className="text-warning">Spares</span> India
              </strong>
            </span>
          </Link>

          <div className="hide-on-desktop">
            <Link to={cust_id ? "/customer/profile" : "/customer/login"} className="text-White mx-2 atag">
              <User />
            </Link>
            <Link to="/cart" className="text-white mx-2 atag position-relative">
              <ShoppingCart />
              {cartCount > 0 && (
                <span className="cart-count" style={{ margin: "-11px -16px 0px 0px" }}>
                  {cartCount}
                </span>
              )}
            </Link>
            <button
              className="navbar-toggler"
              type="button"
              data-bs-toggle="offcanvas"
              data-bs-target="#mobileMenu"
              aria-controls="mobileMenu"
            >
              <span className="text-white">
                <Menu />
              </span>
            </button>
          </div>

          <div className="collapse navbar-collapse">
            <ul className="navbar-nav me-auto ms-auto l1 w-50">
              <SearchCompo categories={categories} />
            </ul>
            <div className="navbar-icons d-flex justify-content-center align-items-center">
              <Link to="/service-repair" className="text-White mx-2 atag" style={{ textDecoration: "underline" }}>
                SERVICE & REPAIR
              </Link>
              <Link to={cust_id ? "/customer/profile" : "/customer/login"} className="text-White mx-2 atag acnt1">
                <User /> {cust_id ? "My Account" : "Login"}
              </Link>
              <UserNotification/>
              <Link to="/cart" className="text-white mx-2 atag position-relative">
                <ShoppingCart />
                {cartCount > 0 && (
                  <span className="cart-count" style={{ margin: "-11px -16px 0px 0px" }}>
                    {cartCount}
                  </span>
                )}
              </Link>
            </div>
          </div>
        </div>
      </nav>

      <div className="topbar1 text-white py-1">
        <div className="container-fluid">
         <nav className="d-flex align-items-center nav-scroll">
  <div className="nav-wrapper">
    {/* 1. Home */}
    <Link to="/" className="text-dark mx-2 mt1 me-3">Home</Link>

    {/* 2. About Us */}
    <Link to="/about-us" className="text-dark mx-2 mt1 me-3">About Us</Link>

    {/* 3-5. Dynamic Categories (Refurbished, Spare Parts, Used/Non-Tested) */}
    {categories.length > 0 && (
      [...categories]
        .filter(cat => [
          "Refurbished Instrument ", 
          "Spare Parts/Accessories ", 
          "Used/Non Tested/As Parts "
        ].includes(cat.title))
        .sort((a, b) => {
          const order = ["Refurbished Instrument ", "Spare Parts/Accessories ", "Used/Non Tested/As Parts "];
          return order.indexOf(a.title) - order.indexOf(b.title);
        })
        .map((category) => (
          <a href={`/searchs/${category.slug}`} key={category.id} className="text-dark mx-2 mt1 me-3">
            {category.title}
          </a>
        ))
    )}

    {/* 6. Service */}
    <Link to="/service-repair" className="text-dark mx-2 mt1 me-3">Service</Link>

    {/* 7-9. Remaining Dynamic Categories (New Instrument, Business Opps, Training) */}
    {categories.length > 0 && (
      [...categories]
        .filter(cat => [
          "New Instrument Sale ", 
          "Business Opportunities  / Acquisition of labs and Industry", 
          "Advance Industrial / Skill Training"
        ].includes(cat.title))
        .sort((a, b) => {
          const order = [
            "New Instrument Sale ", 
            "Business Opportunities  / Acquisition of labs and Industry", 
            "Advance Industrial / Skill Training"
          ];
          return order.indexOf(a.title) - order.indexOf(b.title);
        })
        .map((category) => (
          <a href={`/searchs/${category.slug}`} key={category.id} className="text-dark mx-2 mt1 me-3">
            {category.title}
          </a>
        ))
    )}

    {/* 10. Take Away / Free */}
    <Link to="/education-training" className="text-dark mx-2 mt1 me-3">Take Away / Free</Link>

    {/* 11. Contact Us */}
    {/* <Link to="/contact-us" className="text-dark mx-2 mt1 me-3">Contact Us</Link> */}
  </div>
</nav>
        </div>
      </div>

      {/* Offcanvas Menu for Mobile */}
      <div
        className="offcanvas offcanvas-start"
        tabIndex="-1"
        id="mobileMenu"
        style={{ maxWidth: "75%" }}
        aria-labelledby="mobileMenuLabel"
      >
        <div className="offcanvas-header">
          <div className="d-flex align-items-center">
             <img src={logo} alt="Toolband" className="brand-logo img-fluid logo2 me-2" />
             <small className="fw-bold">TECH SPARES</small>
          </div>
          <button type="button" className="btn-close" data-bs-dismiss="offcanvas" aria-label="Close"></button>
        </div>
        
        <div className="offcanvas-body">
          <ul className="navbar-nav text-start">
            <li className="nav-item">
              <a href="/" className="nav-link mblink">
                <Home size={18} /> Home
              </a>
            </li>
            <li className="nav-item">
              <a href="/about-us" className="nav-link mblink">
                <Pocket size={18} /> About Us
              </a>
            </li>
            <li className="nav-item">
              <a href="/contact-us" className="nav-link mblink">
                <Phone size={18} /> Contact Us
              </a>
            </li>
            <li className="nav-item">
              <a href={cust_id ? "/customer/profile" : "/customer/login"} className="nav-link mblink">
                <User size={18} /> My Account
              </a>
            </li>
            <li className="nav-item">
              <a href={cust_id ? "/customer/profile" : "/customer/login"} className="nav-link mblink">
                <ShoppingCart size={18} /> My Orders
              </a>
            </li>
            {cust_id && (
                <li className="nav-item">
                    <Link to="/logout" className="nav-link mblink text-danger">
                        <LogOut size={18} /> Logout
                    </Link>
                </li>
            )}
          </ul>
          <div className="offcanvas-footer-text">
            © 2026 Tech Spares India
          </div>
        </div>
      </div>

      <div className="hide-on-desktop my-1">
        <SearchCompo categories={categories} />
        <DollarInr />
      </div>
    </header>
  );
}

export default VisitorNavbar;